import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { useMap } from 'react-leaflet';

import _ from 'lodash';

import L from 'leaflet';

const LegendControl = ({ grades, name }) => {
  const map = useMap();

  useEffect(() => {
    console.log('LegendControl useEffect map', map);
    const legend = L.control({ position: 'bottomright' });
    const elements = [];
    {
      _.forEach(grades, (grade) => {
        elements.push(
          <div style={{ height: 25, width: 150 }} key={grade.value}>
            <i style={{ background: grade.color }} />
            {grade.value}
          </div>
        );
      });
    }
    const jsx = (
      <div className="legend" id="legend">
        {name && <h4>{name}</h4>}
        {elements}
      </div>
    );
    legend.onAdd = function () {
      const div = L.DomUtil.create('div', 'info legend');
      ReactDOM.render(jsx, div);
      return div;
    };

    map.addControl(legend);
    return () => map.removeControl(legend);
  }, [map]);
  return null;
};

LegendControl.propTypes = {
  grades: PropTypes.array,
  name: PropTypes.string,
};

LegendControl.defaultProps = {
  grades: [],
  name: '',
};
export default LegendControl;
